import { combineReducers } from 'redux'
import {
  MASTER_RATES_PAGE_ERROR, MASTER_RATES_PAGE_LOADING, MASTER_RATES_LIST_SUCCESS,
  MASTER_RATES_VIEW_SUCCESS, MASTER_RATES_PAGE_SUCCESS, MASTER_RATES_VIEW_ERROR,
  MASTER_RATES_ADD_ERROR, MASTER_RATES_ADD_LOADING, MASTER_RATES_ADD_SUCCESS,
  MASTER_RATES_VIEW_LOADING, MASTER_RATES_DELETE_ERROR, MASTER_RATES_DELETE_LOADING,
  MASTER_RATES_DELETE_SUCCESS, MASTER_RATES_UPDATE_SUCCESS, MASTER_RATES_UPDATE_ERROR, MASTER_RATES_UPDATE_LOADING, MASTER_RATES_DELETE_RATES_ERROR, MASTER_RATES_DELETE_RATES_LOADING, MASTER_RATES_DELETE_RATES_SUCCESS, MASTER_RATES_ADD_RATES_ERROR, MASTER_RATES_ADD_RATES_LOADING, MASTER_RATES_ADD_RATES_SUCCESS
} from './constant'

const masterRatesPageError = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_PAGE_ERROR:
      return action.masterRatesPageError
    default:
      return state
  }
}

const masterRatesPageLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_PAGE_LOADING:
      return action.masterRatesPageLoading
    default:
      return state
  }
}

const masterRatesPageSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_PAGE_SUCCESS:
      return action.masterRatesPageSuccess
    default:
      return state
  }
}

const masterRatess = (state = [], action) => {
  switch (action.type) {
    case MASTER_RATES_PAGE_SUCCESS:
      return action.masterRates
    case MASTER_RATES_LIST_SUCCESS:
      return action.masterRates
    default:
      return state
  }
}

const masterRates = (state = [], action) => {
  switch (action.type) {
    case MASTER_RATES_VIEW_SUCCESS:
      return action.masterRates
    default:
      return state
  }
}

const masterRatesAddError = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_ADD_ERROR:
      return action.masterRatesAddError
    default:
      return state
  }
}

const masterRatesAddLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_ADD_LOADING:
      return action.masterRatesAddLoading
    default:
      return state
  }
}

const masterRatesAddSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_ADD_SUCCESS:
      return action.masterRatesAddSuccess
    default:
      return state
  }
}

const masterRatesViewError = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_VIEW_ERROR:
      return action.masterRatesViewError
    default:
      return state
  }
}

const masterRatesViewLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_VIEW_LOADING:
      return action.masterRatesViewLoading
    default:
      return state
  }
}

const masterRatesViewSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_VIEW_SUCCESS:
      return action.masterRatesViewSuccess
    default:
      return state
  }
}

const masterRatesDeleteError = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_DELETE_ERROR:
      return action.masterRatesDeleteError
    default:
      return state
  }
}

const masterRatesDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_DELETE_LOADING:
      return action.masterRatesDeleteLoading
    default:
      return state
  }
}

const masterRatesDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_DELETE_SUCCESS:
      return action.masterRatesDeleteSuccess
    default:
      return state
  }
}

const masterRatesUpdateError = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_UPDATE_ERROR:
      return action.masterRatesUpdateError
    default:
      return state
  }
}

const masterRatesUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_UPDATE_LOADING:
      return action.masterRatesUpdateLoading
    default:
      return state
  }
}

const masterRatesUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_UPDATE_SUCCESS:
      return action.masterRatesUpdateSuccess
    default:
      return state
  }
}

const masterRatesDeleteRatesError = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_DELETE_RATES_ERROR:
      return action.masterRatesDeleteRatesError
    default:
      return state
  }
}

const masterRatesDeleteRatesLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_DELETE_RATES_LOADING:
      return action.masterRatesDeleteRatesLoading
    default:
      return state
  }
}

const masterRatesDeleteRatesSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_DELETE_RATES_SUCCESS:
      return action.masterRatesDeleteRatesSuccess
    default:
      return state
  }
}

const masterRatesAddRatesError = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_ADD_RATES_ERROR:
      return action.masterRatesAddRatesError
    default:
      return state
  }
}

const masterRatesAddRatesLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_ADD_RATES_LOADING:
      return action.masterRatesAddRatesLoading
    default:
      return state
  }
}

const masterRatesAddRatesSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_RATES_ADD_RATES_SUCCESS:
      return action.masterRatesAddRatesSuccess
    default:
      return state
  }
}

const masterRatesReducer = combineReducers({
  masterRatesPageError,
  masterRatesPageLoading,
  masterRatesPageSuccess,

  masterRatess,
  masterRates,

  masterRatesAddError,
  masterRatesAddLoading,
  masterRatesAddSuccess,

  masterRatesViewError,
  masterRatesViewLoading,
  masterRatesViewSuccess,

  masterRatesDeleteError,
  masterRatesDeleteLoading,
  masterRatesDeleteSuccess,

  masterRatesUpdateError,
  masterRatesUpdateLoading,
  masterRatesUpdateSuccess,

  masterRatesDeleteRatesError,
  masterRatesDeleteRatesLoading,
  masterRatesDeleteRatesSuccess,

  masterRatesAddRatesError,
  masterRatesAddRatesLoading,
  masterRatesAddRatesSuccess,
})

export default masterRatesReducer
